import { useEffect } from "react";
import { useQueryClient } from "react-query";
import ms from "ms";
import { acquireTokenSilently } from "../utils/authProvider";
import { useLoginMutation } from "./useLoginMutation";

export const useTokenRefresh = () => {
  const queryClient = useQueryClient();
  const { mutate: login } = useLoginMutation((err, msg) => {
  if (err) {
    console.error("Token refresh failed:", msg);
  }
});

  useEffect(() => {
    const refreshInterval = setInterval(async () => {
      const token = await acquireTokenSilently();
      if (token) {
        login(token);
      }
    }, ms("11.5h"));

    return () => clearInterval(refreshInterval);
  }, [login]);
};